module.exports = __webpack_public_path__ + "static/img/IMG_20150820_200345.3e8e6990.jpg";